export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7944.da7a77cc.jpg";